if (!customElements.get('cro-sticky-atc')) {
  customElements.define(
    'cro-sticky-atc',
    class CroStickyAtc extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.sectionId = this.dataset.sectionId;
        this.productInfo = this.closest('product-info');
        this.mainButton = this.productInfo?.querySelector(`#ProductSubmitButton-${this.sectionId}`);
        this.price = this.productInfo?.querySelector(`#price-${this.sectionId}`);
        this.button = this.querySelector('[data-cro-sticky-button]');
        this.label = this.querySelector('[data-cro-sticky-label]');
        this.stickyPrice = this.querySelector('[data-cro-sticky-price]');
        this.frame = null;

        if (!this.productInfo || !this.mainButton || !this.button) return;

        this.initialized = true;
        this.onScroll = this.queueVisibility.bind(this);
        this.onClick = this.forwardAddToCart.bind(this);
        this.syncState = this.syncState.bind(this);

        this.button.addEventListener('click', this.onClick);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });

        this.buttonObserver = new MutationObserver(this.syncState);
        this.buttonObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          subtree: true,
        });

        if (this.price) {
          this.priceObserver = new MutationObserver(this.syncState);
          this.priceObserver.observe(this.price, { childList: true, subtree: true });
        }

        this.syncState();
        this.updateVisibility();
      }

      disconnectedCallback() {
        if (!this.initialized) return;

        this.button.removeEventListener('click', this.onClick);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.buttonObserver?.disconnect();
        this.priceObserver?.disconnect();
        if (this.frame) window.cancelAnimationFrame(this.frame);

        this.initialized = false;
        this.frame = null;
      }

      syncState() {
        const mainLabel = this.mainButton.querySelector('span');
        const isDisabled =
          this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';

        this.button.disabled = isDisabled;
        this.button.tabIndex = !isDisabled && this.classList.contains('is-visible') ? 0 : -1;
        this.button.toggleAttribute('aria-busy', this.mainButton.classList.contains('loading'));

        if (mainLabel && this.label) {
          this.label.textContent = mainLabel.textContent.trim();
        }

        if (this.price && this.stickyPrice) {
          const activePrice =
            this.price.querySelector('.price--on-sale .price-item--sale') ||
            this.price.querySelector('.price__regular .price-item--regular') ||
            this.price.querySelector('.price-item--regular');

          if (activePrice) {
            this.stickyPrice.textContent = activePrice.textContent.trim().replace(/\s+/g, ' ');
          }
        }
      }

      forwardAddToCart() {
        if (this.button.disabled) return;
        this.mainButton.click();
      }

      queueVisibility() {
        if (this.frame) return;
        this.frame = window.requestAnimationFrame(() => {
          this.frame = null;
          this.updateVisibility();
        });
      }

      updateVisibility() {
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const buttonRect = this.mainButton.getBoundingClientRect();
        const productRect = this.productInfo.getBoundingClientRect();
        const hasPassedMainButton = buttonRect.bottom < 0;
        const isInsideProduct = productRect.bottom > this.offsetHeight + 8;
        const shouldShow = isMobile && hasPassedMainButton && isInsideProduct;

        this.classList.toggle('is-visible', shouldShow);
        this.toggleAttribute('inert', !shouldShow);
        this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        this.button.tabIndex = shouldShow && !this.button.disabled ? 0 : -1;
      }
    }
  );
}
